<template>
  <!-- Articles -->
  <div
    v-for="(article, index) in props.articles"
    :key="`article_${article.id}`"
    class="article-wrapper"
  >
    <!-- CNC Ads - above article -->
    <DefaultAdsCncWrapper
      :position="UniFeAdsPosition.ABOVE_ARTICLE"
      :page="adPage"
      :index="index"
    />

    <!-- Article -->
    <DefaultArticlesArticleCard
      :article="article"
      :data-index="index"
      :type="index === 0 ? props.firstArticleType || props.articlesType : props.articlesType"
    />

    <!-- CNC Ads - below article -->
    <DefaultAdsCncWrapper
      :position="UniFeAdsPosition.BELOW_ARTICLE"
      :page="adPage"
      :index="index"
    />

  </div>
</template>

<script setup lang="ts">
import type ArticleLocal from "~/libs/interfaces/ArticleLocal"
import type {PropType} from "vue"
import {CncAdsPage} from "~/libs/constants/CncAdsPage"
import {UniFeAdsPosition} from "~/libs/constants/UniFeAdsPosition";
import ArticleComponentType from "~/libs/constants/ArticleComponentType";

const props = defineProps({
  articles: {type: Array as PropType<ArticleLocal[]>, required: true},
  adPage: { type: String as PropType<CncAdsPage>, required: true },
  articlesType: { type: String as PropType<ArticleComponentType>, required: false, default: ArticleComponentType.DEFAULT },
  firstArticleType: { type: String as PropType<ArticleComponentType>, required: false },
})
</script>
